import { confirm, confirmError, init } from './../actions/register.action';
import { createReducer, on, Action } from '@ngrx/store';

import {
  loadForm,
  loadFormSuccess,
  pay,
  payError,
  paySuccess,
  validateForm,
  validateFormError,
  validateFormSuccess,
} from '../actions/register.action';
import {
  RegisterFormStatus,
  RegisterFormState,
} from '../models/register.model';

const initialState: RegisterFormState = {
  step: 1,
  status: RegisterFormStatus.REGISTER_STATE_INITIALIZING,
  errors: null,
  data: null,
  payData: null,
  paymentReceipt: null,
};

function getConfirmErrorMessage(error: any): string {
  if (
    error &&
    error.error &&
    Array.isArray(error.error.message) &&
    error.error.message.length > 0
  ) {
    return error.error.message[0];
  }

  if (error && typeof error.message === 'string' && error.message.length > 0) {
    return error.message;
  }

  if (
    error &&
    Array.isArray(error.message) &&
    error.message.length > 0 &&
    typeof error.message[0] === 'string'
  ) {
    return error.message[0];
  }

  return 'Confirmation failed.';
}

const registerReducer = createReducer(
  initialState,
  on(init, () => initialState),
  on(loadForm, (state: RegisterFormState, { data }) => {
    return {
      ...state,
      step: data.step || 1,
      status:
        data.forceBilling === true
          ? RegisterFormStatus.REGISTER_STATE_VALID
          : RegisterFormStatus.REGISTER_STATE_INITIALIZING,
    };
  }),
  on(loadFormSuccess, (state: RegisterFormState, { data }) => {
    return {
      ...state,
      status: RegisterFormStatus.REGISTER_STATE_READY,
      step: data.step,
      data: data.data,
      confirmation_token: data.confirmation_token,
    };
  }),
  on(validateForm, (state: RegisterFormState, { data }) => {
    return {
      ...state,
      status: RegisterFormStatus.REGISTER_FOR_VALIDATING,
      data,
    };
  }),
  on(validateFormSuccess, (state, { data }) => {
    return {
      ...state,
      status: RegisterFormStatus.REGISTER_STATE_VALID,
      step: data.step,
    };
  }),
  on(validateFormError, (state: RegisterFormState, { error }) => {
    return {
      ...state,
      status: RegisterFormStatus.REGISTER_STATE_INVALID,
      errors: error,
    };
  }),
  on(pay, (state: RegisterFormState, { userData, data }) => {
    return {
      ...state,
      status: RegisterFormStatus.REGISTER_STATE_PAYING,
      data: userData,
      payData: data,
    };
  }),
  on(paySuccess, (state: RegisterFormState, { paymentData }) => {
    return {
      ...state,
      status: RegisterFormStatus.REGISTER_STATE_PAY_VALID,
      paymentReceipt: paymentData,
    };
  }),
  on(payError, (state: RegisterFormState, { error }) => {
    return {
      ...state,
      status: RegisterFormStatus.REGISTER_STATE_PAY_INVALID,
      errors: error,
    };
  }),
  on(confirm, (state: RegisterFormState, { token }) => {
    return {
      ...state,
      status: RegisterFormStatus.REGISTER_STATE_CONFIRM,
      confirmationToken: token,
    };
  }),
  on(confirmError, (state: RegisterFormState, { error }) => {
    return {
      ...state,
      status: RegisterFormStatus.REGISTER_STATE_CONFIRM_ERROR,
      confirmationError: getConfirmErrorMessage(error),
    };
  })
);

export function reducer(state: RegisterFormState, action: Action) {
  return registerReducer(state, action);
}
